/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Bulk_DietInputs */

const en_portal_goal_bulk_diet = /** @type {(inputs: Portal_Goal_Bulk_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2900 kcal over 5 meals`)
};

const pl_portal_goal_bulk_diet = /** @type {(inputs: Portal_Goal_Bulk_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2900 kcal w 5 posiłkach`)
};

/**
* | output |
* | --- |
* | "2900 kcal over 5 meals" |
*
* @param {Portal_Goal_Bulk_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_bulk_diet = /** @type {((inputs?: Portal_Goal_Bulk_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Bulk_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_bulk_diet(inputs)
	return en_portal_goal_bulk_diet(inputs)
});